import { view } from '@yola/ws-sdk';
import { targetClasses } from 'src/js/modules/element-settings/constants/target-classes';
import columnsAmountOptions, {
  columnsAmountValuesByOption,
} from '../constants/columns-amount-options';
import getColumnsAmountOptionByValue from './get-columns-amount-option-by-value';
import hasColPercentageClass from '../verifiers/has-col-percentage-class';

const getUnprefixedColValue = (column) =>
  view.accessors.getResponsiveClassValue({
    element: column,
    className: targetClasses.COL,
  })?.value;

const getColumnsAmountValuesForWidthReset = (columnElements) => {
  const matchedOption = columnElements
    .map((column) => getColumnsAmountOptionByValue(getUnprefixedColValue(column)))
    .find(Boolean);

  return columnsAmountValuesByOption[matchedOption || columnsAmountOptions.THREE_COLUMNS];
};

const getSiblingColumns = (columns) =>
  Array.from(columns[0].closest('ws-columns').querySelectorAll(':scope > ws-column'));

const getBatchToResetCustomColWidth = (elementIds, breakpointKey) => {
  const ids = Array.isArray(elementIds) ? elementIds : [elementIds];
  const columnsToReset = ids.map((id) => view.accessors.getLiveElement(id)).filter(Boolean);

  if (!columnsToReset.length) {
    return {};
  }

  const colValue = getColumnsAmountValuesForWidthReset(getSiblingColumns(columnsToReset))[
    breakpointKey
  ];
  const batch = {};

  columnsToReset.forEach((column) => {
    if (!hasColPercentageClass(column.getAttribute('class'))) {
      return;
    }

    batch[view.accessors.getLiveElementId(column)] = {
      [targetClasses.COL]: colValue,
    };
  });

  return batch;
};

export default getBatchToResetCustomColWidth;
